import React, { FC, Fragment } from 'react';
import { Alert, Box } from '@mui/material';
import { Deviation, DeviationAction } from 'models/deviations';
import DeviationItem from 'components/order-details/main-order-view/deviation-section/deviation-item/deviation-item.component';
import { useTranslation } from 'react-i18next';
import InfoText from 'components/shared/info-text.component';

type DeviationListProps = {
    deviations: Deviation[];
    onOpenUpdateModal: (deviation: Deviation) => void;
    onOpenConfirmDialog: (deviationId: string) => void;
    onActionDialogOpen: (deviationId: string) => void;
    onOpenUpdateActionModal: (deviationId: string, deviationAction: DeviationAction) => void;
    onOpenConfirmActionDialog: (deviationId: string, actionId: string) => void;
    versionCheck: boolean;
};

const DeviationList: FC<DeviationListProps> = ({
    deviations,
    onOpenUpdateModal,
    onOpenConfirmDialog,
    onActionDialogOpen,
    onOpenUpdateActionModal,
    onOpenConfirmActionDialog,
    versionCheck,
}: DeviationListProps) => {
    const { t: translate } = useTranslation(['deviations']);
    // DD-3846: the list can hold empty entries (a deviation that could not be resolved); skip them.
    const visibleDeviations = (deviations || []).filter((deviation) => !!deviation?._id);

    return (
        <Fragment>
            {visibleDeviations.length > 0 ? (
                <Fragment>
                    {visibleDeviations.map((deviation) => (
                        <Box key={deviation._id} mb={2}>
                            <DeviationItem
                                deviation={deviation}
                                onOpenUpdateModal={onOpenUpdateModal}
                                onOpenConfirmDialog={onOpenConfirmDialog}
                                onActionDialogOpen={onActionDialogOpen}
                                onOpenUpdateActionModal={onOpenUpdateActionModal}
                                onOpenConfirmActionDialog={onOpenConfirmActionDialog}
                                versionCheck={versionCheck}
                            />
                        </Box>
                    ))}
                </Fragment>
            ) : (
                <InfoText text={translate('deviations:NO_DEVIATIONS')} />
            )}
        </Fragment>
    );
};

export default DeviationList;
